import { render, staticRenderFns } from "./Payroll.vue?vue&type=template&id=7fa096e6&scoped=true&"
import script from "./Payroll.vue?vue&type=script&setup=true&lang=js&"
export * from "./Payroll.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa096e6",
  null
  
)

export default component.exports